module.exports = __webpack_public_path__ + "static/img/1.469fb0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1.png
// module id = LOA1
// module chunks = 0